import React, { useState, useEffect } from 'react';
import './TaskForm.css';

function EditTaskModal({
  task,
  users = [],
  projects = [],
  onClose,
  onSave,
  isSubtask
}) {
  const [title, setTitle] = useState('');
  const [status, setStatus] = useState('');
  const [responsible, setResponsible] = useState('');
  const [validator, setValidator] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [notes, setNotes] = useState('');
  const [project, setProject] = useState('');

  useEffect(() => {
    if (task) {
      setTitle(task.title || '');
      setStatus(task.status || '');
      setResponsible(task.responsible || '');
      setValidator(task.validator || '');
      setDueDate(task.dueDate ? task.dueDate.split('T')[0] : '');
      setNotes(task.notes || '');
      setProject(task.project || '');
    }
  }, [task]);

  const handleSave = () => {
    const updatedTask = {
      ...task,
      title,
      status,
      responsible,
      validator,
      dueDate,
      notes
    };

    if (!isSubtask) {
      updatedTask.project = project;
    }

    onSave(updatedTask);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content form-container edit-task-modal">
        <h2>{isSubtask ? 'Editar Subtarea' : 'Editar Tarea'}</h2>

        <div className="form-group full-width">
          <label>Título:</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        {!isSubtask && (
          <div className="form-group full-width">
            <label>Proyecto:</label>
            <div className="modal-select-shell accent-purple">
              <select
                value={project}
                onChange={(e) => setProject(e.target.value)}
              >
                {projects
                  .filter((item) => item.isDefault)
                  .map((item) => (
                    <option key={item._id} value={item._id}>
                      Sin proyecto
                    </option>
                  ))}

                {projects
                  .filter((item) => !item.isDefault)
                  .map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        )}

        <div className="form-group full-width">
          <label>Estado:</label>
          <div className="modal-select-shell accent-yellow">
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">Selecciona</option>
              <option value="Nueva">Nueva</option>
              <option value="Trabajando">Trabajando</option>
              <option value="Bloqueada">Bloqueada</option>
              <option value="Pendiente">Pendiente</option>
              <option value="Completada">Completada</option>
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Responsable:</label>
            <div className="modal-select-shell accent-coral">
              <select
                value={responsible}
                onChange={(e) => setResponsible(e.target.value)}
              >
                <option value="">Selecciona</option>
                {users.map((user) => (
                  <option key={user._id} value={user._id}>
                    {user.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Validador:</label>
            <div className="modal-select-shell accent-teal">
              <select
                value={validator}
                onChange={(e) => setValidator(e.target.value)}
              >
                <option value="">Selecciona</option>
                {users.map((user) => (
                  <option key={user._id} value={user._id}>
                    {user.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="form-group full-width">
          <label>Fecha de entrega:</label>

          <div className="modal-date-shell accent-teal">
            <input
              type="date"
              className={dueDate ? 'has-date-value' : ''}
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
            />

            <span className="modal-date-placeholder">
              Día / Mes / Año
            </span>
          </div>
        </div>

        <div className="form-group full-width">
          <label>Notas:</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>

        <div className="form-buttons">
          <button
            type="button"
            className="modal-primary-button"
            onClick={handleSave}
          >
            Guardar cambios
          </button>

          <button
            type="button"
            className="modal-secondary-button"
            onClick={onClose}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditTaskModal;
